(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shiply-b2b-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-shiply-mobile-menu]').forEach((menu) => {
      if (menu.dataset.initialized === 'true') return;
      menu.dataset.initialized = 'true';

      const header = menu.closest('.shiply-header');
      const openButton = header?.querySelector('[data-shiply-menu-open]');
      const closeButtons = menu.querySelectorAll('[data-shiply-menu-close]');
      const focusableSelector = 'a[href], button:not([disabled])';
      let closeTimer;

      const closeMenu = () => {
        window.clearTimeout(closeTimer);
        menu.classList.remove('is-open');
        openButton?.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('shiply-menu-open');
        closeTimer = window.setTimeout(() => {
          menu.hidden = true;
          openButton?.focus();
        }, 220);
      };

      const openMenu = () => {
        window.clearTimeout(closeTimer);
        menu.hidden = false;
        openButton?.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('shiply-menu-open');
        window.requestAnimationFrame(() => {
          menu.classList.add('is-open');
          menu.querySelector('.shiply-mobile-menu__close')?.focus();
        });
      };

      openButton?.addEventListener('click', openMenu);
      closeButtons.forEach((button) => button.addEventListener('click', closeMenu));
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));

      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeMenu();
          return;
        }

        if (event.key !== 'Tab') return;
        const focusable = Array.from(menu.querySelectorAll(focusableSelector));
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const cart = event.cartData;
        if (!cart) return;

        document.querySelectorAll('[data-shiply-cart-count]').forEach((count) => {
          count.textContent = cart.item_count;
        });
        const total = document.querySelectorAll('[data-shiply-cart-total]');
        if (total) {
          total.textContent = new Intl.NumberFormat('en-PH', {
            style: 'currency',
            currency: cart.currency || 'PHP',
          }).format(cart.total_price / 100);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shiply-calculator-overrides"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const peso = new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const percent = new Intl.NumberFormat('en-PH', { style: 'percent', maximumFractionDigits: 2 });
    const totalPercent = new Intl.NumberFormat('en-PH', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const rates = {
      transaction: 0.0224,
      mallShipping: 0.0448,
      marketplaceShipping: 0.056,
      fixedOrder: 5,
      megaVoucher: 0.04,
      liveXtra: 0.0336,
      withholding: 0.005
    };
    const categoryRates = {
      'Audio': 0.01, 'Baby & Kids Fashion': 0.01, 'Beauty': 0.015, 'Books & Magazines': 0.015,
      'Cameras & Drones': 0.01, 'Computers & Accessories': 0.01, 'Fashion Accessories': 0.01,
      'Food & Beverages': 0.01, 'Gaming & Consoles': 0.01, 'Health': 0.015,
      'Hobbies & Collections': 0.015, 'Home & Living': 0.015, 'Home Appliances': 0.01,
      'Men Bags': 0.01, 'Men Clothes': 0.01, 'Men Shoes': 0.01, 'Mobile & Gadgets': 0.01,
      'Mom & Baby': 0.01, 'Motorcycles': 0.015, 'Pets': 0.01, 'Sports & Outdoors': 0.015,
      'Stationery': 0.015, 'Travel & Luggage': 0.015, 'Women Bags': 0.01,
      'Women Clothes': 0.01, 'Women Shoes': 0.01
    };
    const commissionRates = {
      'Audio': { mall: 0.0824, marketplace: 0.095 },
      'Baby & Kids Fashion': { mall: 0.0996, marketplace: 0.105 },
      'Beauty': { mall: 0.1036, marketplace: 0.1 },
      'Books & Magazines': { mall: 0.0996, marketplace: 0.105 },
      'Cameras & Drones': { mall: 0.0824, marketplace: 0.085 },
      'Computers & Accessories': { mall: 0.0824, marketplace: 0.09 },
      'Fashion Accessories': { mall: 0.0996, marketplace: 0.1 },
      'Food & Beverages': { mall: 0.0772, marketplace: 0.095 },
      'Gaming & Consoles': { mall: 0.0824, marketplace: 0.095 },
      'Health': { mall: 0.0924, marketplace: 0.1 },
      'Hobbies & Collections': { mall: 0.0974, marketplace: 0.105 },
      'Home & Living': { mall: 0.0996, marketplace: 0.105 },
      'Home Appliances': { mall: 0.0824, marketplace: 0.095 },
      'Men Bags': { mall: 0.0996, marketplace: 0.1 },
      'Men Clothes': { mall: 0.0996, marketplace: 0.105 },
      'Men Shoes': { mall: 0.0996, marketplace: 0.1 },
      'Mobile & Gadgets': { mall: 0.0612, marketplace: 0.09 },
      'Mom & Baby': { mall: 0.0812, marketplace: 0.1 },
      'Motorcycles': { mall: 0.0996, marketplace: 0.1 },
      'Pets': { mall: 0.0924, marketplace: 0.1 },
      'Sports & Outdoors': { mall: 0.0996, marketplace: 0.105 },
      'Stationery': { mall: 0.0996, marketplace: 0.105 },
      'Travel & Luggage': { mall: 0.1108, marketplace: 0.105 },
      'Women Bags': { mall: 0.0996, marketplace: 0.1 },
      'Women Clothes': { mall: 0.0996, marketplace: 0.105 },
      'Women Shoes': { mall: 0.0996, marketplace: 0.1 }
    };

    function number(form, name) {
      const field = form.elements[name];
      const value = field ? Number(field.value) : 0;
      return Number.isFinite(value) ? value : 0;
    }

    function checked(form, name) {
      const field = form.elements[name];
      return Boolean(field && field.checked);
    }

    function metric(label, value, className) {
      const modifier = className ? ` ${className}` : '';
      return `<div class="shiply-marketplace-tool__metric${modifier}"><dt>${label}</dt><dd>${value}</dd></div>`;
    }

    function packing(form) {
      return number(form, 'packagingContainer') + number(form, 'packagingCushion') + number(form, 'packagingSeal') + number(form, 'packagingOther');
    }

    function currentCategory(form) {
      const option = form.elements.category ? form.elements.category.value : 'Home & Living';
      return option || 'Home & Living';
    }

    function sellerGrowthRate(form) {
      return categoryRates[currentCategory(form)] || 0.015;
    }

    function scenario(form, channel, priceOverride) {
      const salePrice = Math.max(0, priceOverride || number(form, 'salePrice'));
      const commissionRate = (commissionRates[currentCategory(form)] || commissionRates['Home & Living'])[channel];
      const shippingRate = channel === 'mall' ? rates.mallShipping : rates.marketplaceShipping;
      const commission = salePrice * commissionRate;
      const transaction = salePrice * rates.transaction;
      const shipping = Math.min(salePrice * shippingRate, 100) + rates.fixedOrder;
      const sellerGrowth = checked(form, 'sellerGrowth') ? salePrice * sellerGrowthRate(form) : 0;
      const megaVoucher = checked(form, 'megaVoucher') ? salePrice * rates.megaVoucher : 0;
      const liveXtra = checked(form, 'liveXtra') ? salePrice * rates.liveXtra : 0;
      const spaylaterRate = number(form, 'spaylater') / 100;
      const spaylater = salePrice * spaylaterRate;
      const beforeTax = commission + transaction + shipping + sellerGrowth + megaVoucher + liveXtra + spaylater;
      const withholding = checked(form, 'withholdingTax') ? Math.max(0, salePrice - beforeTax) * rates.withholding : 0;
      const fees = beforeTax + withholding;
      const net = salePrice - fees;
      const gross = net - number(form, 'productCost') - packing(form);
      const margin = salePrice > 0 ? gross / salePrice : 0;
      return { salePrice, commissionRate, commission, transaction, shippingRate, shipping, sellerGrowth, megaVoucher, liveXtra, spaylaterRate, spaylater, withholding, fees, net, gross, margin };
    }

    function targetPrice(form, channel) {
      const target = number(form, 'targetMargin') / 100;
      let low = Math.max(1, number(form, 'productCost') + packing(form));
      let high = Math.max(low * 2, number(form, 'salePrice'), 100);
      for (let i = 0; i < 30; i += 1) {
        if (scenario(form, channel, high).margin >= target) break;
        high *= 1.5;
      }
      for (let i = 0; i < 40; i += 1) {
        const mid = (low + high) / 2;
        if (scenario(form, channel, mid).margin >= target) high = mid;
        else low = mid;
      }
      return high;
    }

    function render(root, channel) {
      const form = root.querySelector('[data-calculator-form]');
      const panel = root.querySelector(`[data-result-panel="${channel}"]`);
      const result = scenario(form, channel);
      const rows = [
        metric('Sales price', peso.format(result.salePrice)),
        metric(`Commission (${percent.format(result.commissionRate)})`, peso.format(result.commission)),
        metric(`Transaction Fee (${percent.format(rates.transaction)})`, peso.format(result.transaction)),
        metric(`Shipping Fee (${percent.format(result.shippingRate)} + ${peso.format(rates.fixedOrder)})`, peso.format(result.shipping))
      ];
      if (result.megaVoucher > 0) rows.push(metric(`Mega Discount Voucher (${percent.format(rates.megaVoucher)})`, peso.format(result.megaVoucher)));
      if (result.sellerGrowth > 0) rows.push(metric(`Seller Growth Support Fee (${percent.format(sellerGrowthRate(form))})`, peso.format(result.sellerGrowth)));
      if (result.liveXtra > 0) rows.push(metric(`Live Xtra (${percent.format(rates.liveXtra)})`, peso.format(result.liveXtra)));
      if (result.spaylater > 0) rows.push(metric(`SPayLater (${percent.format(result.spaylaterRate)})`, peso.format(result.spaylater)));
      if (result.withholding > 0) rows.push(metric('Withholding Tax', peso.format(result.withholding)));
      rows.push(metric(`Total Fees (${totalPercent.format(result.salePrice > 0 ? result.fees / result.salePrice : 0)})`, peso.format(result.fees), 'is-total'));
      rows.push(metric('Net marketplace payout', peso.format(result.net), 'is-net'));
      [
        ['Pouch or box', number(form, 'packagingContainer')],
        ['Bubble wrap', number(form, 'packagingCushion')],
        ['Tape and label', number(form, 'packagingSeal')],
        ['Other packing cost', number(form, 'packagingOther')]
      ].filter((row) => row[1] > 0).forEach((row) => rows.push(metric(row[0], peso.format(row[1]))));
      rows.push(metric('Gross profit after packing', peso.format(result.gross), 'is-profit'));
      rows.push(metric('Margin %', percent.format(result.margin), 'is-margin'));
      rows.push(metric(`Suggested price for target Margin (${percent.format(number(form, 'targetMargin') / 100)})`, peso.format(targetPrice(form, channel))));
      panel.querySelector('dl').innerHTML = rows.join('');
      panel.querySelector(`[data-result="${channel}Margin"]`).innerHTML = `${percent.format(result.margin)} <span>Margin</span>`;
    }

    function apply(root) {
      const form = root.querySelector('[data-calculator-form]');
      if (!form) return;
      if (!form.dataset.shiplyDefaultsApplied) {
        if (form.elements.packagingContainer) form.elements.packagingContainer.value = '2.00';
        if (form.elements.packagingOther) form.elements.packagingOther.value = '0.00';
        ['megaVoucher', 'sellerGrowth', 'liveXtra', 'withholdingTax'].forEach((name) => {
          if (form.elements[name]) form.elements[name].checked = true;
        });
        form.dataset.shiplyDefaultsApplied = 'true';
      }
      const saleLabel = form.querySelector('input[name="salePrice"]')?.closest('label')?.querySelector('span');
      if (saleLabel) saleLabel.textContent = 'Sales price';
      const sellerLabel = form.elements.sellerGrowth?.closest('label')?.querySelector('span');
      if (sellerLabel) sellerLabel.textContent = `Seller Growth Fee ${percent.format(sellerGrowthRate(form))}`;
      const heading = form.querySelector('.shiply-marketplace-tool__section-heading');
      if (heading && !form.querySelector('.shiply-marketplace-tool__form-note')) {
        heading.insertAdjacentHTML('afterend', '<p class="shiply-marketplace-tool__form-note">Enter your sales price, product cost, category, and optional programs to estimate your Shopee payout and margin.</p>');
      }
      const toggles = form.querySelector('.shiply-marketplace-tool__toggle-grid');
      if (toggles && !form.querySelector('.shiply-marketplace-tool__toggle-note')) {
        toggles.insertAdjacentHTML('afterend', '<p class="shiply-marketplace-tool__toggle-note">Checked programs are included in the fee breakdown.</p>');
      }
      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) submitButton.textContent = 'Update calculation';
      render(root, 'mall');
      render(root, 'marketplace');
    }

    document.querySelectorAll('[data-marketplace-calculator]').forEach((root) => {
      const nav = root.querySelector('.shiply-marketplace-tool__nav');
      if (nav && !root.querySelector('.shiply-marketplace-tool__guide-links')) {
        nav.insertAdjacentHTML('afterend', '<nav class="shiply-marketplace-tool__guide-links" aria-label="Shopee seller guides"><span>Related Shopee guides</span><a href="/pages/shopee-fees-guide-philippines">Shopee Fee Guide</a><a href="/pages/shopee-commission-rates-philippines">Shopee Commission Rates</a></nav>');
      }
      const form = root.querySelector('[data-calculator-form]');
      form.addEventListener('input', () => apply(root));
      form.addEventListener('change', () => apply(root));
      form.addEventListener('submit', () => window.setTimeout(() => apply(root), 0));
      form.addEventListener('reset', () => {
        delete form.dataset.shiplyDefaultsApplied;
        window.setTimeout(() => apply(root), 0);
      });
      root.querySelector('[data-reset-calculator]')?.addEventListener('click', () => {
        delete form.dataset.shiplyDefaultsApplied;
        window.setTimeout(() => apply(root), 0);
      });
      window.setTimeout(() => apply(root), 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shiply-calculator-target-margin-label"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const percent = new Intl.NumberFormat('en-PH', {
      style: 'percent',
      maximumFractionDigits: 2
    });

    function number(form, name) {
      const field = form.elements[name];
      const value = field ? Number(field.value) : 0;
      return Number.isFinite(value) ? value : 0;
    }

    function applyTargetMarginLabel() {
      document.querySelectorAll('[data-marketplace-calculator]').forEach((root) => {
        const form = root.querySelector('[data-calculator-form]');
        if (!form) return;

        const target = percent.format(number(form, 'targetMargin') / 100);
        root.querySelectorAll('[data-result-panel] .shiply-marketplace-tool__metric dt').forEach((label) => {
          if (label.textContent.trim().startsWith('Suggested price for target Margin')) {
            label.textContent = `Suggested price for target Margin (${target})`;
          }
        });
      });
    }

    function scheduleTargetMarginLabel() {
      window.setTimeout(applyTargetMarginLabel, 0);
      window.setTimeout(applyTargetMarginLabel, 40);
      window.setTimeout(applyTargetMarginLabel, 160);
      window.setTimeout(applyTargetMarginLabel, 500);
      window.setTimeout(applyTargetMarginLabel, 1000);
    }

    function watchTargetMarginLabels() {
      document.querySelectorAll('[data-marketplace-calculator]').forEach((root) => {
        if (root.dataset.shiplyTargetMarginObserver) return;
        const observer = new MutationObserver(scheduleTargetMarginLabel);
        observer.observe(root, {
          childList: true,
          subtree: true,
          characterData: true
        });
        root.dataset.shiplyTargetMarginObserver = 'true';
      });
    }

    document.addEventListener('input', scheduleTargetMarginLabel, true);
    document.addEventListener('change', scheduleTargetMarginLabel, true);
    document.addEventListener('click', scheduleTargetMarginLabel, true);
    document.addEventListener('submit', scheduleTargetMarginLabel, true);
    document.addEventListener('DOMContentLoaded', () => {
      watchTargetMarginLabels();
      applyTargetMarginLabel();
    });
    window.addEventListener('load', () => {
      watchTargetMarginLabels();
      applyTargetMarginLabel();
    });
    window.setInterval(() => {
      watchTargetMarginLabels();
      applyTargetMarginLabel();
    }, 250);
    watchTargetMarginLabels();
    applyTargetMarginLabel();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shiply-marketplace-calculator"] && !Shopify.designMode) return;
  try {
    
  const calculatorRoots = document.querySelectorAll('[data-marketplace-calculator]');

  const feeData = {
    shopee: {
      fixedOrderFee: 5,
      transactionRate: 0.0224,
      mallShippingRate: 0.0448,
      marketplaceShippingRate: 0.056,
      shippingCap: 100,
      optional: {
        megaVoucher: 0.04,
        sellerGrowth: 0.015,
        liveXtra: 0.0336,
        withholdingTax: 0.005
      },
      categories: [
        { name: 'Audio', mall: 0.0824, marketplace: 0.095 },
        { name: 'Baby & Kids Fashion', mall: 0.0996, marketplace: 0.105 },
        { name: 'Beauty', mall: 0.1036, marketplace: 0.1 },
        { name: 'Books & Magazines', mall: 0.0996, marketplace: 0.105 },
        { name: 'Cameras & Drones', mall: 0.0824, marketplace: 0.085 },
        { name: 'Computers & Accessories', mall: 0.0824, marketplace: 0.09 },
        { name: 'Fashion Accessories', mall: 0.0996, marketplace: 0.1 },
        { name: 'Food & Beverages', mall: 0.0772, marketplace: 0.095 },
        { name: 'Gaming & Consoles', mall: 0.0824, marketplace: 0.095 },
        { name: 'Health', mall: 0.0924, marketplace: 0.1 },
        { name: 'Hobbies & Collections', mall: 0.0974, marketplace: 0.105 },
        { name: 'Home & Living', mall: 0.0996, marketplace: 0.105 },
        { name: 'Home Appliances', mall: 0.0824, marketplace: 0.095 },
        { name: 'Men Bags', mall: 0.0996, marketplace: 0.1 },
        { name: 'Men Clothes', mall: 0.0996, marketplace: 0.105 },
        { name: 'Men Shoes', mall: 0.0996, marketplace: 0.1 },
        { name: 'Mobile & Gadgets', mall: 0.0612, marketplace: 0.09 },
        { name: 'Mom & Baby', mall: 0.0812, marketplace: 0.1 },
        { name: 'Motorcycles', mall: 0.0996, marketplace: 0.1 },
        { name: 'Pets', mall: 0.0924, marketplace: 0.1 },
        { name: 'Sports & Outdoors', mall: 0.0996, marketplace: 0.105 },
        { name: 'Stationery', mall: 0.0996, marketplace: 0.105 },
        { name: 'Travel & Luggage', mall: 0.1108, marketplace: 0.105 },
        { name: 'Women Bags', mall: 0.0996, marketplace: 0.1 },
        { name: 'Women Clothes', mall: 0.0996, marketplace: 0.105 },
        { name: 'Women Shoes', mall: 0.0996, marketplace: 0.1 }
      ]
    }
  };

  const peso = new Intl.NumberFormat('en-PH', {
    style: 'currency',
    currency: 'PHP',
    maximumFractionDigits: 2
  });

  const percent = new Intl.NumberFormat('en-PH', {
    style: 'percent',
    maximumFractionDigits: 1
  });

  function numberValue(form, name) {
    const field = form.elements[name];
    const value = field ? Number(field.value) : 0;
    return Number.isFinite(value) ? value : 0;
  }

  function isChecked(form, name) {
    const field = form.elements[name];
    return Boolean(field && field.checked);
  }

  function selectedCategory(form) {
    const categoryName = form.elements.category.value;
    return feeData.shopee.categories.find((category) => category.name === categoryName) || feeData.shopee.categories[0];
  }

  function packagingCost(form) {
    return numberValue(form, 'packagingContainer') + numberValue(form, 'packagingCushion') + numberValue(form, 'packagingSeal') + numberValue(form, 'packagingOther');
  }

  function optionalRate(form) {
    let rate = 0;
    if (isChecked(form, 'megaVoucher')) rate += feeData.shopee.optional.megaVoucher;
    if (isChecked(form, 'sellerGrowth')) rate += feeData.shopee.optional.sellerGrowth;
    if (isChecked(form, 'liveXtra')) rate += feeData.shopee.optional.liveXtra;
    if (isChecked(form, 'withholdingTax')) rate += feeData.shopee.optional.withholdingTax;
    rate += numberValue(form, 'spaylater') / 100;
    return rate;
  }

  function calculateScenario(form, channel, priceOverride) {
    const salePrice = Math.max(0, priceOverride || numberValue(form, 'salePrice'));
    const cost = Math.max(0, numberValue(form, 'productCost'));
    const packing = Math.max(0, packagingCost(form));
    const category = selectedCategory(form);
    const commissionRate = channel === 'mall' ? category.mall : category.marketplace;
    const shippingRate = channel === 'mall' ? feeData.shopee.mallShippingRate : feeData.shopee.marketplaceShippingRate;
    const commission = salePrice * commissionRate;
    const transaction = salePrice * feeData.shopee.transactionRate;
    const shipping = Math.min(salePrice * shippingRate, feeData.shopee.shippingCap) + feeData.shopee.fixedOrderFee;
    const optional = salePrice * optionalRate(form);
    const fees = commission + transaction + shipping + optional;
    const netRevenue = salePrice - fees;
    const grossProfit = netRevenue - cost - packing;
    const margin = salePrice > 0 ? grossProfit / salePrice : 0;
    return {
      salePrice,
      cost,
      packing,
      commissionRate,
      commission,
      transaction,
      shipping,
      optional,
      fees,
      netRevenue,
      grossProfit,
      margin
    };
  }

  function targetPrice(form, channel) {
    const target = numberValue(form, 'targetMargin') / 100;
    let low = Math.max(1, numberValue(form, 'productCost') + packagingCost(form));
    let high = Math.max(low * 2, numberValue(form, 'salePrice'), 100);

    for (let i = 0; i < 30; i += 1) {
      const result = calculateScenario(form, channel, high);
      if (result.margin >= target) break;
      high *= 1.5;
    }

    for (let i = 0; i < 40; i += 1) {
      const mid = (low + high) / 2;
      const result = calculateScenario(form, channel, mid);
      if (result.margin >= target) {
        high = mid;
      } else {
        low = mid;
      }
    }

    return high;
  }

  function metric(label, value) {
    return `<div class="shiply-marketplace-tool__metric"><dt>${label}</dt><dd>${value}</dd></div>`;
  }

  function renderPanel(root, channel, result, suggested) {
    const panel = root.querySelector(`[data-result-panel="${channel}"]`);
    const margin = panel.querySelector(`[data-result="${channel}Margin"]`);
    const list = panel.querySelector('dl');
    margin.textContent = percent.format(result.margin);
    list.innerHTML = [
      metric('Commission', `${peso.format(result.commission)} (${percent.format(result.commissionRate)})`),
      metric('Transaction fee', peso.format(result.transaction)),
      metric('Shipping fee and order fee', peso.format(result.shipping)),
      metric('Optional programs and tax', peso.format(result.optional)),
      metric('Packaging cost', peso.format(result.packing)),
      metric('Total Shopee fees', peso.format(result.fees)),
      metric('Net marketplace payout', peso.format(result.netRevenue)),
      metric('Gross profit after packing', peso.format(result.grossProfit)),
      metric('Suggested price for target margin', peso.format(suggested))
    ].join('');
    panel.classList.toggle('is-negative', result.grossProfit < 0);
  }

  function pushToolEvent(name, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      marketplace_tool: detail
    });
  }

  function updateCalculator(root) {
    const form = root.querySelector('[data-calculator-form]');
    const mall = calculateScenario(form, 'mall');
    const marketplace = calculateScenario(form, 'marketplace');
    renderPanel(root, 'mall', mall, targetPrice(form, 'mall'));
    renderPanel(root, 'marketplace', marketplace, targetPrice(form, 'marketplace'));
  }

  calculatorRoots.forEach((root) => {
    const form = root.querySelector('[data-calculator-form]');
    const categorySelect = root.querySelector('[data-category-select]');
    categorySelect.innerHTML = feeData.shopee.categories.map((category) => `<option value="${category.name}">${category.name}</option>`).join('');
    categorySelect.value = 'Home & Living';

    form.addEventListener('input', () => updateCalculator(root));
    form.addEventListener('change', () => updateCalculator(root));
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      updateCalculator(root);
      pushToolEvent('marketplace_calculator_submit', {
        platform: 'shopee',
        category: form.elements.category.value,
        sale_price: numberValue(form, 'salePrice')
      });
    });

    root.querySelector('[data-reset-calculator]').addEventListener('click', () => {
      form.reset();
      categorySelect.value = 'Home & Living';
      updateCalculator(root);
    });

    root.querySelectorAll('.shiply-marketplace-tool__nav a').forEach((link) => {
      link.addEventListener('click', () => {
        pushToolEvent('marketplace_calculator_nav_click', {
          label: link.textContent.trim(),
          href: link.getAttribute('href')
        });
      });
    });

    root.querySelectorAll('.shiply-marketplace-tool__links a').forEach((link) => {
      link.addEventListener('click', () => {
        pushToolEvent('marketplace_calculator_cta_click', {
          label: link.textContent.trim(),
          href: link.getAttribute('href')
        });
      });
    });

    updateCalculator(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shiply-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-shiply-newsletter-popup]').forEach((popup) => {
      if (popup.dataset.initialized === 'true') return;
      popup.dataset.initialized = 'true';

      const dialog = popup.querySelector('dialog');
      const closeButtons = popup.querySelectorAll('[data-shiply-popup-close]');
      const copyButton = popup.querySelector('[data-shiply-copy-code]');
      const storageKey = 'shiply-newsletter-popup-dismissed-at';
      const subscribedKey = 'shiply-newsletter-popup-subscribed';
      const cartCount = Number.parseInt(popup.dataset.cartCount || '0', 10);
      const dismissDays = Number.parseInt(popup.dataset.dismissDays || '14', 10);
      const entryDelay = Number.parseInt(popup.dataset.entryDelay || '5000', 10);
      const successVisible = popup.querySelector('.shiply-newsletter-popup__success') !== null;
      const errorVisible = popup.querySelector('.shiply-newsletter-popup__error') !== null;
      let hasShown = false;
      let cartHasItems = cartCount > 0;

      const dismissedRecently = () => {
        const dismissedAt = Number.parseInt(window.localStorage.getItem(storageKey) || '0', 10);
        if (!dismissedAt) return false;
        return Date.now() - dismissedAt < dismissDays * 24 * 60 * 60 * 1000;
      };

      const markDismissed = () => {
        window.localStorage.setItem(storageKey, Date.now().toString());
      };

      const showPopup = () => {
        if (hasShown) return;
        if (!successVisible) {
          if (cartHasItems) return;
          if (window.localStorage.getItem(subscribedKey) === 'true') return;
          if (dismissedRecently()) return;
        }

        hasShown = true;
        popup.hidden = false;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        document.documentElement.classList.add('shiply-newsletter-popup-open');
        popup.querySelector('input[type="email"], [data-shiply-copy-code], button')?.focus();
      };

      const closePopup = () => {
        markDismissed();
        document.documentElement.classList.remove('shiply-newsletter-popup-open');
        if (dialog.open && typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        popup.hidden = true;
      };

      closeButtons.forEach((button) => button.addEventListener('click', closePopup));
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePopup();
      });

      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (form && form.matches('form[action*="/cart/add"]')) {
          cartHasItems = true;
        }
      });

      document.addEventListener('mouseleave', (event) => {
        if (event.clientY <= 0) {
          showPopup();
        }
      });

      copyButton?.addEventListener('click', () => {
        const code = copyButton.dataset.shiplyCopyCode;
        if (!code) return;
        navigator.clipboard?.writeText(code);
        copyButton.textContent = 'Copied';
        window.localStorage.setItem(subscribedKey, 'true');
      });

      if (successVisible || errorVisible) {
        if (successVisible) {
          window.localStorage.setItem(subscribedKey, 'true');
        }
        window.setTimeout(showPopup, 300);
        return;
      }

      window.setTimeout(showPopup, entryDelay);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
